import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { workPlannerApi } from "@/services/workPlannerApi";

const STATUS_COLORS = {
  to_do: "bg-slate-100 text-slate-700", in_progress: "bg-blue-100 text-blue-700",
  review: "bg-amber-100 text-amber-700", completed: "bg-green-100 text-green-700",
  cancelled: "bg-red-100 text-red-700",
};

export default function WorkPlannerList() {
  const [activities, setActivities] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    workPlannerApi.listActivities(statusFilter ? { status: statusFilter } : {})
      .then((d) => setActivities(d.activities || []))
      .finally(() => setLoading(false));
  }, [statusFilter]);

  const isOverdue = (t) => t.status !== "completed" && t.due_date && t.due_date < new Date().toISOString().slice(0, 10);

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-semibold">Client Work Planner — All Activities</h1>
        <div className="flex items-center gap-3">
          <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} className="rounded-lg border border-slate-300 px-3 py-2 text-sm">
            <option value="">All statuses</option>
            <option value="to_do">Planned</option>
            <option value="in_progress">In Progress</option>
            <option value="review">Under Review</option>
            <option value="completed">Completed</option>
            <option value="cancelled">Cancelled</option>
          </select>
          <Link to="/work-hub/planner" className="rounded-lg border border-slate-300 px-4 py-2 text-sm font-medium text-slate-600 hover:border-slate-400">← Choose client</Link>
        </div>
      </div>
      {loading ? (
        <div className="text-sm text-slate-500">Loading…</div>
      ) : activities.length === 0 ? (
        <div className="text-sm text-slate-500">No work-planner activities yet. Create a monthly plan to get started.</div>
      ) : (
        <div className="overflow-x-auto rounded-lg border border-slate-200">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-left text-slate-500">
              <tr><th className="p-3">Activity</th><th className="p-3">Client</th><th className="p-3">Service</th>
                <th className="p-3">Due</th><th className="p-3">Priority</th><th className="p-3">Status</th><th className="p-3">Assigned</th></tr>
            </thead>
            <tbody>
              {activities.map((t) => (
                <tr key={t._id} className="border-t border-slate-100">
                  <td className="p-3">
                    {/* Tasks.js opens task detail via local component state (openEditTask),
                        not a URL param — no deep-link target exists yet, so this stays plain
                        text. Open the Tasks module and search by title to view/comment on it. */}
                    {t.title}
                    {isOverdue(t) && <span className="ml-2 rounded-full bg-red-100 px-2 py-0.5 text-xs text-red-700">Overdue</span>}
                  </td>
                  <td className="p-3">{t.client_id}</td>
                  <td className="p-3">{t.service}</td>
                  <td className="p-3">{t.due_date}</td>
                  <td className="p-3 capitalize">{t.priority}</td>
                  <td className="p-3"><span className={`rounded-full px-2 py-1 text-xs ${STATUS_COLORS[t.status] || "bg-slate-100"}`}>{t.status}</span></td>
                  <td className="p-3">{(t.assigned_users || []).length}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
